import { MapRE } from "@/game-eft/constants/constants.mjs";

const factory: readonly [string, string] = ["eft:map.factory", "Factory"];

const mapTranslations: { [key: string]: readonly [string, string] } = {
  Customs: ["eft:map.customs", "Customs"],
  "Factory Day": factory,
  "Factory Night": factory,
  Factory: factory,
  Interchange: ["eft:map.interchange", "Interchange"],
  Lighthouse: ["eft:map.lighthouse", "Lighthouse"],
  Reserve: ["eft:map.reserve", "Reserve"],
  Shoreline: ["eft:map.shoreline", "Shoreline"],
  Streets: ["eft:map.streets", "Streets"],
  "The Lab": ["eft:map.lab", "The Lab"],
  Woods: ["eft:map.woods", "Woods"],
  "Ground Zero": ["eft:map.groundZero", "Ground Zero"],
  Hideout: ["eft:map.hideout", "Hideout"],
  newMap: ["eft:map.newMap", "New Map"], // This doesn't actually exist in the game, we use this as a placeholder for new maps
};

// This accepts either the RE map (raw) or BE (translated) map names
export default function getMapName(map: string): readonly [string, string] {
  return (
    mapTranslations[MapRE[map] ?? map] ??
    // If a new map is released, update the MapRE + mapTranslations
    mapTranslations.newMap
  );
}
